import superagent from "superagent";

const request = superagent.agent()
    .use((req: any) => {
        req.on("response", (res: any) => {
            if (res.status === 401) {
                window.location.href = "/logout";
            }
        });
    });

export default request;


// WEBPACK FOOTER //
// ./src/Apis/BaseRequest.ts